// src/components/ServerDataExtraction/ServerDataExtractionHeader.jsx
import React, { useState } from 'react';

const ServerDataExtractionHeader = () => {

    // Removed ipAddress state and handlers
  
    return (
      // Keep mb-8 for spacing before ServerInfoCard
      <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
        <div className="relative overflow-hidden bg-gradient-to-r from-dark-500 via-dark-600 to-dark-500 rounded-2xl p-6 md:p-8 border border-dark-400 hover:border-accent-blue/30 transition-medium group">
          {/* Background effects */}
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-accent-blue opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>
          <div className="absolute -left-20 -bottom-20 w-56 h-56 bg-accent-green opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>
  
          <div className="flex flex-col md:flex-row items-center justify-between z-10 relative">
            {/* Left side: Text */}
            <div className="w-full md:w-2/3 lg:w-1/2 mb-6 md:mb-0 text-center md:text-left">
              <div className="inline-flex items-center text-sm font-medium text-accent-blue mb-2 animate-pulse-slow bg-accent-blue/10 px-3 py-1 rounded-full">
                <i className="fas fa-database mr-2"></i>
                SERVER DATA EXTRACTION MODULE
              </div>
              <h2 className="text-3xl font-bold mb-3 group-hover:text-white transition-colors">
                Retrieve Server
                <span className="gradient-text inline-block ml-2 group-hover:animate-pulse-text bg-gradient-to-r from-accent-blue to-accent-green">Data</span>
              </h2>
              <p className="text-gray-400 text-sm max-w-md mx-auto md:mx-0 group-hover:text-gray-300 transition-colors">
                Connect to a target server below to retrieve available data like MOTD, player lists, plugins, and more.
              </p>
              {/* Input and Button Area REMOVED */}
            </div>
  
            {/* Right side: Data Extraction Themed Graphic */}
            <div className="w-full md:w-1/3 lg:w-1/2 md:pl-8 flex items-center justify-center mt-6 md:mt-0 opacity-60 md:opacity-100 group-hover:opacity-100 transition-opacity duration-300">
               <div className="relative w-48 h-48 group-hover:scale-105 transition-transform duration-500">
                 {/* Orbiting elements */}
                 <div className="absolute inset-0 border-2 border-accent-blue/20 rounded-full animate-spin-slow">
                   <div className="absolute w-3 h-3 bg-accent-blue rounded-full top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></div>
                   <div className="absolute w-2 h-2 bg-accent-green rounded-full bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2"></div>
                 </div>
                 <div className="absolute inset-4 border border-dashed border-accent-green/20 rounded-full animate-spin-slow-reverse">
                    <div className="absolute w-2 h-2 bg-accent-green rounded-full top-1/2 left-0 transform -translate-x-1/2 -translate-y-1/2"></div>
                 </div>
                 {/* Central icon */}
                 <div className="absolute inset-8 flex items-center justify-center text-center">
                    <i className="fas fa-server text-5xl text-accent-blue opacity-50 animate-pulse-slow"></i>
                    <i className="fas fa-database text-3xl text-accent-green opacity-70 absolute animate-ping-slow delay-500"></i>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default ServerDataExtractionHeader;